import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ['ar', 'en'],
        ns: ['translation'],
        defaultNS: 'translation',
        load: 'languageOnly',
        detection: {
            order: [
                'cookie',
                'querystring',
                'localStorage',
                'sessionStorage',
                'htmlTag',
                'path',
            ],
            caches: ['cookie', 'localStorage'],
            lookupCookie: 'i18nextLng',
            lookupLocalStorage: 'i18nextLng',
            lookupSessionStorage: 'i18nextLng',
            lookupQuerystring: 'lng',
            lookupFromPathIndex: 0,
            lookupFromSubdomainIndex: 0,
            cookieMinutes: 10080, // 1 week
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
            addPath: '/locales/add/{{lng}}/{{ns}}',
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
            bindI18n: 'languageChanged loaded',
            bindI18nStore: 'added removed',
            transEmptyNodeValue: '',
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        },
        preload: ['ar', 'en'],
    });

// Detect language from the current path on initialization
const detectLangFromPath = (): 'ar' | 'en' => {
    try {
        if (typeof window === 'undefined' || !window.location) return 'ar';
        const pathname = window.location.pathname || '/';
        const m = pathname.match(/^\/(ar|en)(?=\/|$)/);
        if (m && m[1]) return m[1] === 'ar' ? 'ar' : 'en';
    } catch (e) {
        // ignore
    }
    return 'ar';
};

// Initialize language based on path or fallback to detector
const initialLang = detectLangFromPath();
if (initialLang) {
    i18n.changeLanguage(initialLang).catch((err) => {
        console.error('Error setting initial language:', err);
    });
}

export default i18n;
